// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { scrollToTop } from "@rugby/XDL/Utilities/utilities";
import React, { FC, useEffect, useState } from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState) => ({
    pages: state.data.pages,
});

const ScrollToTop: FC<any> = props => {
    const [location, setLocation] = useState(props.pages.location);

    // for hard refresh
    useEffect(() => {
        window &&
            window.addEventListener(
                "load",
                () => {
                    scrollToTop();
                },
                false,
            );
    }, []);

    // for react router
    useEffect(() => {
        scrollToTop();
        setLocation(props.pages.location);
    }, [props.pages.location]);

    return null;
};

export default connect(mapStateToProps)(ScrollToTop);
